module.exports = __webpack_public_path__ + "static/web_Tarjetas_Cuenca-3ea89e45768debcbbcd8552a7476409c.jpg";